import { Icon, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import EDProgressBar from './EDProgressBar'

const EDHeader = ({ title, icon, progress, result }) => {
  const CardStyle = () => {
    return {
      bgcolor: 'white.main',
      borderRadius: 3,
      padding: 2,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0px 0px 10px lightgray',
      minHeight: 80,
    }
  }

  const IconStyle = () => {
    return {
      display: 'flex',
      marginRight: 2,
      minWidth: 40,
      height: 40,
      borderRadius: 50,
      justifyContent: 'center',
      alignItems: 'center',
      bgcolor: 'alternate.light',
      color: 'alternate.main',
    }
  }

  return (
    <Box sx={{ ...CardStyle() }}>
      <Box display="flex" alignItems="center">
        <Box sx={{ ...IconStyle() }}>
          <Icon sx={{ fontSize: 20 }}>{icon}</Icon>
        </Box>
        <Typography noWrap variant="h4" textTransform="capitalize" fontWeight="bold">
          {title}
        </Typography>
      </Box>

      {/* progress bar */}
      <Box
        width={3.5 / 7}
        display="flex"
        gap={3}
        alignItems="center"
        justifyContent="space-between"
      >
        {progress !== 100 ? (
          <EDProgressBar
            progress={progress}
            sx={{ width: '400px', height: '10px', borderRadius: '5px' }}
          />
        ) : (
          <Box width="400px" display="flex" gap={1} alignItems="center" justifyContent="flex-end">
            <Icon sx={{ fontSize: 20, color: 'positive.main' }}>check_circle</Icon>
            <Typography color="light-gray-text.main">Completed</Typography>
          </Box>
        )}
        <Typography color="light-gray-text.main" noWrap>
          {result} result(s)
        </Typography>
      </Box>
    </Box>
  )
}

export default EDHeader
